// extracted by mini-css-extract-plugin
export default {"page":"ChangePasswordForm_page__hKPAF"};